class PortalClinicoCadastroForm extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.tagsInput = this.querySelector('[data-cadastro-tags]');

    if (!this.form || !this.tagsInput) {
      return;
    }

    this.baseTags = this.dataset.baseTags
      ? this.dataset.baseTags.split(',').map((tag) => tag.trim()).filter(Boolean)
      : [];

    this.form.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }

  onSubmit = () => {
    const name = this.querySelector('[data-cadastro-name]')?.value.trim();
    const phone = this.querySelector('[data-cadastro-phone]')?.value.trim();
    const state = this.querySelector('[data-cadastro-state]')?.value.trim();
    const crm = this.querySelector('[data-cadastro-crm]')?.value.trim();
    const profession = this.querySelector('[data-cadastro-profession]')?.value.trim();
    const tags = new Set(this.baseTags);

    if (name) {
      tags.add(`nome:${name}`);
      this.setHiddenField('contact[first_name]', this.firstNameFrom(name));
      this.setHiddenField('contact[last_name]', this.lastNameFrom(name));
      this.setHiddenField('contact[note][nome]', name);
    }

    if (phone) {
      tags.add(`telefone:${phone}`);
      this.setHiddenField('contact[note][telefone]', phone);
    }

    if (state) {
      tags.add(`estado:${state}`);
      this.setHiddenField('contact[note][estado]', state);
    }

    if (crm) {
      tags.add(`crm:${crm}`);
      this.setHiddenField('contact[note][crm]', crm);
    }

    if (profession) {
      tags.add(`profissao:${profession}`);
      this.setHiddenField('contact[note][profissao]', profession);
    }

    this.tagsInput.value = [...tags].join(', ');
  };

  setHiddenField(name, value) {
    if (!value) {
      return;
    }

    let input = this.form.querySelector(`input[name="${CSS.escape(name)}"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      this.form.appendChild(input);
    }

    input.value = value;
  }

  firstNameFrom(name) {
    const parts = name.split(/\s+/).filter(Boolean);
    return parts[0] || name;
  }

  lastNameFrom(name) {
    const parts = name.split(/\s+/).filter(Boolean);
    return parts.slice(1).join(' ');
  }
}

if (typeof customElements.get('portal-clinico-cadastro-form') === 'undefined') {
  customElements.define('portal-clinico-cadastro-form', PortalClinicoCadastroForm);
}
